"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toml_1 = __importDefault(require("@tauri-apps/toml"));
var chalk_1 = __importDefault(require("chalk"));
var fs_1 = __importDefault(require("fs"));
var os_1 = __importDefault(require("os"));
var path_1 = __importDefault(require("path"));
var app_paths_1 = require("../helpers/app-paths");
var cross_spawn_1 = require("cross-spawn");
var non_webpack_require_1 = __importDefault(require("../helpers/non-webpack-require"));
var package_json_1 = __importDefault(require("../../package.json"));
var get_script_version_1 = __importDefault(require("../helpers/get-script-version"));
var util_1 = require("./dependency-manager/util");
function crateLatestVersion(name) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, util_1.getCrateLatestVersion(name)];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, undefined];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/* eslint-disable security/detect-non-literal-fs-filename */
function dirTree(filename, recurse) {
    if (recurse === void 0) { recurse = true; }
    var stats = fs_1.default.lstatSync(filename);
    var info = {
        path: filename,
        name: path_1.default.basename(filename)
    };
    if (stats.isDirectory()) {
        info.type = 'folder';
        if (recurse) {
            info.children = fs_1.default.readdirSync(filename).map(function (child) {
                return dirTree(filename + '/' + child, false);
            });
        }
    }
    else {
        info.type = 'file';
    }
    return info;
}
function getVersion(command, args, formatter) {
    if (args === void 0) { args = []; }
    var version = get_script_version_1.default(command, args);
    if (version === null) {
        return chalk_1.default.red('Not installed');
    }
    else {
        return chalk_1.default.green(formatter === undefined ? version : formatter(version));
    }
}
function printInfo(info) {
    var suffix = info.suffix ? " " + info.suffix : '';
    console.log("" + (info.section ? '\n' : '') + info.key + (info.value === undefined ? '' : ' - ' + info.value) + suffix);
}
function printVersion(info) {
    var outdated = info.version &&
        info.targetVersion &&
        util_1.semverLt(info.version, info.targetVersion);
    console.log("" + (info.section ? '\n' : '') + info.key + (info.version
        ? ' - ' + chalk_1.default.green(info.version)
        : chalk_1.default.red('Not installed')) +
        (outdated && info.targetVersion
            ? " (" + chalk_1.default.red('outdated, latest: ' + info.targetVersion) + ")"
            : ''));
}
function readTomlFile(filepath) {
    try {
        var file = fs_1.default.readFileSync(filepath).toString();
        return toml_1.default.parse(file);
    }
    catch (_) {
        return null;
    }
}
function printAppInfo(tauriDir) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var lockPath, lock, lockPackages, manifestPath, manifest, tauriVersion, foundTauriVersions, manifestVersion, lockVersion, tauriVersionString, latestTauriCore, tauriMode, configPath, config;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    printInfo({ key: 'App', section: true });
                    lockPath = path_1.default.join(tauriDir, 'Cargo.lock');
                    lock = readTomlFile(lockPath);
                    lockPackages = lock
                        ? lock.package.filter(function (pkg) { return pkg.name === 'tauri'; })
                        : [];
                    manifestPath = path_1.default.join(tauriDir, 'Cargo.toml');
                    manifest = readTomlFile(manifestPath);
                    foundTauriVersions = [];
                    if (manifest && lock && lockPackages.length === 1) {
                        // everything looks good
                        foundTauriVersions.push(lockPackages[0].version);
                        tauriVersion = chalk_1.default.green(lockPackages[0].version);
                    }
                    else if (lock && lockPackages.length === 1) {
                        // good lockfile, but no manifest - will cause problems building
                        foundTauriVersions.push(lockPackages[0].version);
                        tauriVersion = chalk_1.default.green(lockPackages[0].version) + " (" + chalk_1.default.red('no manifest') + ")";
                    }
                    else {
                        manifestVersion = function () {
                            var tauri = manifest === null || manifest === void 0 ? void 0 : manifest.dependencies.tauri;
                            if (tauri) {
                                if (typeof tauri === 'string') {
                                    foundTauriVersions.push(tauri);
                                    return chalk_1.default.yellow(tauri);
                                }
                                else if (tauri.version) {
                                    foundTauriVersions.push(tauri.version);
                                    return chalk_1.default.yellow(tauri.version);
                                }
                                else if (tauri.path) {
                                    var manifestPath_1 = path_1.default.resolve(tauriDir, tauri.path, 'Cargo.toml');
                                    var manifestContent = readTomlFile(manifestPath_1);
                                    var pathVersion = manifestContent === null || manifestContent === void 0 ? void 0 : manifestContent.package.version;
                                    pathVersion = pathVersion
                                        ? chalk_1.default.yellow(pathVersion)
                                        : chalk_1.default.red(pathVersion);
                                    return "path:" + tauri.path + " [" + pathVersion + "]";
                                }
                            }
                            else {
                                return chalk_1.default.red('no manifest');
                            }
                            return chalk_1.default.red('unknown manifest');
                        };
                        lockVersion = void 0;
                        if (lock && lockPackages.length > 0) {
                            lockVersion = chalk_1.default.yellow(lockPackages.map(function (p) { return p.version; }).join(', '));
                        }
                        else if (lock && lockPackages.length === 0) {
                            lockVersion = chalk_1.default.red('unknown lockfile');
                        }
                        else {
                            lockVersion = chalk_1.default.red('no lockfile');
                        }
                        tauriVersion = manifestVersion() + " (" + chalk_1.default.yellow(lockVersion) + ")";
                    }
                    tauriVersionString = foundTauriVersions.reduce(function (old, current) { return (util_1.semverLt(old, current) ? current : old); }, '0.0.0');
                    return [4 /*yield*/, crateLatestVersion('tauri')];
                case 1:
                    latestTauriCore = _b.sent();
                    printInfo({
                        key: '  tauri.rs',
                        value: tauriVersion,
                        suffix: tauriVersionString !== '0.0.0' &&
                            latestTauriCore &&
                            util_1.semverLt(tauriVersionString, latestTauriCore)
                            ? "(" + chalk_1.default.red('outdated, latest: ' + latestTauriCore) + ")"
                            : undefined
                    });
                    try {
                        tauriMode = function (config) {
                            if (config.tauri.embeddedServer) {
                                return chalk_1.default.green(config.tauri.embeddedServer.active ? 'embedded-server' : 'no-server');
                            }
                            return chalk_1.default.red('unset');
                        };
                        configPath = path_1.default.join(tauriDir, 'tauri.conf.json');
                        config = non_webpack_require_1.default(configPath);
                        printInfo({ key: '  mode', value: tauriMode(config) });
                        printInfo({
                            key: '  build-type',
                            value: ((_a = config.tauri.bundle) === null || _a === void 0 ? void 0 : _a.active) ? 'bundle' : 'build'
                        });
                        printInfo({
                            key: '  CSP',
                            value: config.tauri.security ? config.tauri.security.csp : 'unset'
                        });
                        printInfo({
                            key: '  distDir',
                            value: config.build
                                ? chalk_1.default.green(config.build.distDir)
                                : chalk_1.default.red('unset')
                        });
                        printInfo({
                            key: '  devPath',
                            value: config.build
                                ? chalk_1.default.green(config.build.devPath)
                                : chalk_1.default.red('unset')
                        });
                    }
                    catch (_) { }
                    return [2 /*return*/];
            }
        });
    });
}
module.exports = function () { return __awaiter(void 0, void 0, void 0, function () {
    var stdout, match, edgeString, _a, _b, tree, _i, _c, artifact;
    var _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                printInfo({
                    key: 'Operating System',
                    value: chalk_1.default.green(os_1.default.type() + "(" + os_1.default.release() + ") - " + os_1.default.platform() + "/" + os_1.default.arch()),
                    section: true
                });
                if (os_1.default.platform() === 'win32') {
                    stdout = cross_spawn_1.sync('REG', [
                        'QUERY',
                        'HKEY_CLASSES_root\\AppX3xxs313wwkfjhythsb8q46xdsq8d2cvv\\Application',
                        '/v',
                        'ApplicationName'
                    ]).stdout;
                    match = /{(\S+)}/g.exec(stdout.toString());
                    if (match) {
                        edgeString = match[1];
                        printInfo({
                            key: 'Microsoft Edge',
                            value: edgeString.split('?')[0].replace('Microsoft.MicrosoftEdge_', '')
                        });
                    }
                }
                printInfo({ key: 'Node.js environment', section: true });
                printVersion({
                    key: '  Node.js',
                    version: process.version.slice(1),
                    targetVersion: package_json_1.default.engines.node.replace('>= ', '')
                });
                _a = printVersion;
                _d = {
                    key: '  tauri.js',
                    version: package_json_1.default.version
                };
                return [4 /*yield*/, util_1.getNpmLatestVersion('tauri')];
            case 1:
                _a.apply(void 0, [(_d.targetVersion = _f.sent(),
                        _d)]);
                printInfo({ key: 'Rust environment', section: true });
                printInfo({
                    key: '  rustc',
                    value: getVersion('rustc', [], function (output) { return output.split(' ')[1]; })
                });
                printInfo({
                    key: '  cargo',
                    value: getVersion('cargo', [], function (output) { return output.split(' ')[1]; })
                });
                _b = printVersion;
                _e = {
                    key: '  tauri-bundler',
                    version: get_script_version_1.default('cargo', ['tauri-bundler'])
                };
                return [4 /*yield*/, crateLatestVersion('tauri-bundler')];
            case 2:
                _b.apply(void 0, [(_e.targetVersion = _f.sent(),
                        _e)]);
                printInfo({ key: 'Global packages', section: true });
                printInfo({ key: '  NPM', value: getVersion('npm') });
                printInfo({ key: '  yarn', value: getVersion('yarn') });
                printInfo({ key: 'App directory structure', section: true });
                tree = dirTree(app_paths_1.appDir);
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                for (_i = 0, _c = tree.children || []; _i < _c.length; _i++) {
                    artifact = _c[_i];
                    if (artifact.type === 'folder') {
                        console.log("/" + artifact.name);
                    }
                }
                return [4 /*yield*/, printAppInfo(app_paths_1.tauriDir)];
            case 3:
                _f.sent();
                return [2 /*return*/];
        }
    });
}); };
/* eslint-enable security/detect-non-literal-fs-filename */
